import clsx from 'clsx';
import React from 'react';

import TagPill from './TagPill';

import { TagType } from '../types';

interface AssignedTagsProps {
  assignedTags: TagType[];
  rowId: string | number;
  onRemoveTag: (tagIndex: number) => void; // for delete from project
  onUnassignTag?: (tagIndex: number) => void; // for unassign from file only
  onEdit: (tagIndex: number) => void;
  isFilesTable?: boolean;
  style?: React.CSSProperties;
  isLibrary?: boolean;
  isTagReadOnly?: boolean;
  refetchAllFiles?: () => void;
}

const AssignedTags: React.FC<AssignedTagsProps> = ({
  assignedTags,
  onRemoveTag,
  onUnassignTag,
  onEdit,
  isFilesTable,
  style,
  isLibrary = false,
  isTagReadOnly = false,
}) => {
  const containerRef = React.useRef<HTMLDivElement>(null);

  const handleEditTag = (tagIndex: number) => {
    if (!isTagReadOnly) onEdit(tagIndex);
  };

  const handleTagPillClick = () => {
    onEdit(-1);
  };

  const handleRemoveTag = (tagIndex: number) => {
    if (!isTagReadOnly && onUnassignTag) onUnassignTag(tagIndex);
  };
  const visibleTags = assignedTags?.length <= 2 ? assignedTags : assignedTags?.slice(0, 2);

  return (
    <div
      ref={containerRef}
      className={clsx(
        'tw-flex',
        isFilesTable ? 'tw-p-[12px]' : 'tw-p-[0px]',
        'tw-relative',
        'tw-bg-transparent',
        isFilesTable ? 'tw-flex-wrap' : 'tw-flex-nowrap',
        'tw-items-center',
        'tw-gap-2',
        'tw-cursor-pointer',
        'tw-rounded',
        'tw-max-w-[300px]'
      )}
      style={{
        minWidth: isFilesTable ? '300px' : 'auto',
        justifyContent: !isFilesTable ? 'flex-start' : 'center',
        overflowX: isFilesTable ? undefined : 'unset',
        whiteSpace: isFilesTable ? undefined : 'nowrap',
        position: isLibrary ? 'absolute' : 'relative',
        ...style,
      }}
    >
      {visibleTags.map((tag, tagIndex) => (
        <TagPill
          key={tag.id || tag.name}
          tag={tag}
          removable={!isTagReadOnly}
          onRemove={() => handleRemoveTag(tagIndex)} // X button only unassigns
          onDelete={() => onRemoveTag(tagIndex)} // Delete menu calls onRemoveTag (delete from project)
          onEdit={() => handleEditTag(tagIndex)}
          style={{ backgroundColor: tag.color || '#ffffff' }}
          className={tag.color}
          isTagReadOnly={isTagReadOnly}
          onClick={(e: React.MouseEvent) => {
            if (e && e.target instanceof HTMLElement) {
              if (
                e.target.closest('button[aria-label="Tag options"]') ||
                e.target.closest('button[aria-label="Edit tag"]') ||
                e.target.closest('button[aria-label="Delete tag"]')
              ) {
                return;
              }
            }
            handleTagPillClick();
          }}
        />
      ))}
      {assignedTags?.length > 2 && (
        <button
          className="tw-px-2 tw-py-1 tw-bg-cfo-grey-200 tw-rounded-full tw-text-sm tw-ml-1"
          onClick={(e) => {
            e.stopPropagation();
            handleTagPillClick();
          }}
          // disabled={isTagReadOnly}
        >
          +{assignedTags?.length - 2}
        </button>
      )}
    </div>
  );
};

export default AssignedTags;
